// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"d7cefbd5","66":"de7851d3","95":"80c9fb79","213":"dd1b06ae","234":"ab8a95b1","241":"98715050","453":"f961bb9e","476":"d1bfe0fb","546":"71282ad4","629":"1382c797","655":"dfaf25fb","936":"83f45f22"}[chunkId] + ".chunk.js";
};